import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import ToastPlugin from 'vue-toast-notification';
import VueMobileDetection from "vue-mobile-detection/";
// Import one of the available themes
import 'vue-toast-notification/dist/theme-default.css';
import 'vue-toast-notification/dist/theme-bootstrap.css';
import "bootstrap/dist/css/bootstrap.rtl.min.css"
import "bootstrap"
import "./assets/font.css"
import bottomNavigationVue from "bottom-navigation-vue";
// import "bottom-navigation-vue/dist/style.css";
import "./assets/css/custom.css"
import "./assets/css/fontawesome.css"
import "./assets/css/all.css"
window.$ = window.jQuery = require('jquery');

loadFonts()

createApp(App)
  .use(router)
  .use(vuetify)
  .use(ToastPlugin)
  .use(bottomNavigationVue)
  .use(VueMobileDetection)
  .mount('#app')
